import React from 'react';
import CrmSyncActions from 'actions/crm/CrmSyncActions';
import LibraryActions from 'actions/library/LibraryActions';
import CoachingReviewActions from 'actions/coaching/CoachingReviewActions';
import FileUploadCallCardStore from 'stores/files/FileUploadCallCardStore';
import SearchSidebarContainer from './search-sidebar/SearchSidebarContainer';
import './CallsPage.styl';

export default class Calls extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {};
    this.onFileUploadCallCardStoreUpdate = this.onFileUploadCallCardStoreUpdate.bind(this);
  }

  componentDidMount() {
    setTimeout(() => LibraryActions.getLibraries(), 0);
    setTimeout(() => LibraryActions.getTags(), 0);
    // connectToStores was buggy and was not updating here
    // just manually do listening/unlistening
    FileUploadCallCardStore.listen(this.onFileUploadCallCardStoreUpdate);
  }

  componentWillUnmount() {
    FileUploadCallCardStore.unlisten(this.onFileUploadCallCardStoreUpdate);
    setImmediate(() => {
      // XXX The reviewRedirect flag is used with the AddCallsDialog to handle a redirect
      // back to the review screen when we are linked to this page from there.
      // This call just handles setting it back to default if the user navigates away
      // either through the redirect or any other means
      CoachingReviewActions.setReviewRedirect(false);
      CrmSyncActions.resetSupportsCloudSynced();
    });
  }

  onFileUploadCallCardStoreUpdate(state) {
    this.setState({isScorecardToggled: state.isScorecardToggled});
  }

  render() {
    return (
      <div className="calls-page">
        {!this.state.isScorecardToggled && (
          <SearchSidebarContainer key="SearchSidebarContainer" location={this.props.location} />
        )}
        <div className="content">{this.props.children}</div>
      </div>
    );
  }
}
